import script from "./quick_store_component.vue?vue&type=script&setup=true&lang=js"
export * from "./quick_store_component.vue?vue&type=script&setup=true&lang=js"

import "./quick_store_component.vue?vue&type=style&index=0&id=6118c1fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6118c1fe"]])

export default __exports__